import React from "react";

const TeacherAbout = ({teacher}) => {
    return (
        <div className="nw-flex-h flex-no-wrap flex-wrap-on-small-tablet col-gap-lg" style={{width: '100%'}}>
            <div className="nw-unit nw-unit-grow span-on-small-tablet">
                <p className="sub-menu-header">Biography</p>
                
                <div className="teacher-detail_biography" style={{width: '100%', lineHeight: '1.5em'}}>
                    <p>{teacher.bio}</p>
                </div>
            </div>
            <div class="nw-unit nw-unit-1-3 flex-no-shrink span-on-small-tablet">
                <p className="sub-menu-header">Research Interests</p>
                <div className="nw-flex-h gap-sm">
                {
                    teacher.research_interests.map((c)=> (
                        <div className="research-interest-item">{c}</div>
                    ))
                }     
                </div>           
            </div>

        </div>
    ) 
};

export default TeacherAbout;
